import { EnumUtil } from '@csp/csp-common-enum-util';
import { CommonHcpWebPath } from '@csp/csp-common-routes';
import { RoleType } from '@csp/dmdp-api-common-dto';
import { Maybe } from '../common/model/Monadish';
import { EmailJobGrouping } from './EmailJobGrouping';

export type EmailJobConfig = {
  code: string;
  cronPattern: string;
  roles: RoleType[];
  patientColumnLink?: CommonHcpWebPath;
  groupBy: EmailJobGrouping;
};

const from = ({
  code,
  cronPattern,
  roles,
  patientColumnLink,
  groupBy,
}: {
  code: string;
  cronPattern: string;
  roles: RoleType[];
  patientColumnLink: Maybe<string>;
  groupBy: Maybe<string>;
}): EmailJobConfig => ({
  code,
  cronPattern,
  roles,
  patientColumnLink: EnumUtil.fromMaybeString<CommonHcpWebPath>(patientColumnLink, CommonHcpWebPath),
  groupBy: EnumUtil.fromMaybeStringOrDefault<EmailJobGrouping>(groupBy, EmailJobGrouping, EmailJobGrouping.STUDY),
});

export const EmailJobConfig = {
  from,
};
